const config = {
    ENV: 'DEVELOPMENT',
    apiEndpoint: '/api/',
    languages: ['ka', 'en'],
    get authIframeUrl() {
        return `${config.apiEndpoint}auth/iframe`;
    },
    ssoSdkUrl: 'https://account.bog.ge/ssosdk/sdk.js?channel=BOG&v.2.2',
    chatFrameUrl: 'https://publisher.bog.ge/chat-api/?channel=sologe&header=false',
    chatTrustedOrigin: 'https://publisher.bog.ge',
    ssoTrustedOrigins: [
        'https://solo.ge',
        'https://solo.k8s.bog.ge',
        'https://account.bog.ge',
        'https://account-test.bog.ge',
        'https://solo-test.bog.ge',
        'https://solo-staging.bog.ge',
        'https://solo-test.bog.ge',
        'https://solo-beta.bog.ge',
        'https://solo-prod.bog.ge',
    ],
    recaptchaSiteKey: '6LeHfhAaAAAAAE4Vn1bqohpK6jdy6MZx14O3KKnc',
    rbcUrl: 'https://rb-api.bog.ge/rb-middleware-api-connector?',
    ramadUrl: 'https://ramad.bog.ge/s3/solo',
    productMenuUrls: {
        ibank: 'https://www.ibank.bog.ge',
        bonline: 'https://www.bonline.bog.ge',
        businessManager: 'https://manager.bog.ge',
        bogpay: 'https://bogpay.ge',
        bogge: 'https://www.bog.ge',
    },
    sentryDSN: 'https://f5895d9ad2217c0f80e6599303f939ba@o570631.ingest.us.sentry.io/4507372205178880',
};
export default config;
